import { actionCreator } from '@ardoq/rxbeach';

export const activateComponentFab = actionCreator(
  '[mainApp/fab/componentFab] ACTIVATE_COMPONENT_FAB'
);
